/*
 * @Description:
 */

import h5Api from '../h5'
import webApi from '../web'
import apis from './platformApis'

export const getStandSystem = function () {
  const searchParams = new URLSearchParams(window.location.search)
  // 通过参数名 "inxbb" 获取对应的值
  const inxbb = searchParams.get('inxbb') || '' // inxbb 表示销帮帮通过ifrmae打开ai。此时需要使用webApi

  const u = navigator.userAgent
  console.log('当前环境', u)
  if (u.indexOf('Html5Plus') > -1 && !inxbb) {
    return 'h5'
  }
  return 'web'
}

const system = getStandSystem()
let fun = null

switch (system) {
  case 'web':
    fun = { ...webApi }
    break
  case 'h5':
    fun = { ...h5Api }
    break
  default:
    break
}

// api加载
function apiInit(type, { name, data }) {
  try {
    if (!apis[type][name]) return
    // throw new Error(`暂无--${name}`)
    if (apis[type][name].includes(system)) return data ? fun[name](data) : fun[name]()
    // throw new Error(`${name}--仅在${apis[type][name].toString()}环境适用`)
  } catch (e) {
    console.warn(e)
  }
}

export function useEnvApi(data) {
  return apiInit('envFunApi', data)
}

export function useApi(data) {
  return apiInit('normalApi', data)
}

export function useDeepApi(data) {
  return apiInit('deepApi', data)
}
